/**
 * authorization redux actions
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {LOGIN_SUCCESS} from "./consts";
import {LOGOUT} from "../authorization/consts"; // TODO: how to handle global actions?


export const loginSuccessAction = (accessToken, userInfo, roleInfo, typeInfo) => ({
    type: LOGIN_SUCCESS,
    accessToken: accessToken,
    userInfo: userInfo,
    roleInfo: roleInfo,
    typeInfo: typeInfo
});

export const logoutAction = () => ({
    type: LOGOUT
});